export default [
  {
    path: '/tokens',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'TokensMain',
        component: () => import('./containers/TokensContainer'),
        children: [
          {
            path: 'history',
            name: 'TokensHistory',
            component: () => import('./containers/TokensHistoryContainer'),
            children: [
              {
                path: 'ask',
                component: () => import('./containers/TokensAskContainer'),
              },
            ],
          },
          {
            path: 'demands',
            name: 'TokensDemand',
            component: () => import('./containers/TokensDemandContainer'),
            children: [
              {
                path: 'ask',
                component: () => import('./containers/TokensAskContainer'),
              },
              {
                path: ':demandId',
                props: true,
                component: () => import('./containers/TokensDemandViewContainer'),
              },
            ],
          },
        ],
      },
    ],
  },
]
